var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"morm_app"},_vm._l((_vm.mormTitle),function(item){return _c('div',{key:item.id,staticClass:"morm_app_list",on:{"click":function($event){return _vm.titleFun(item)}}},[_c('p',{staticClass:"type_app_list"},[_vm._v(_vm._s(item.name))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fdcb9b0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appModule/bouncedMormApp/mormComponent.vue
// module id = null
// module chunks = 